<script setup lang="ts">
import type {IPromiseTariff} from "~/stores/useCustomTariffStore";

const { t } = useI18n();
const config = useRuntimeConfig();
const { queryRefParams } = useHttpReferrer();

defineProps<{ item: IPromiseTariff, tag?: string }>();
</script>

<template>
  <div class="price-item">
    <div v-if="tag" class="price-item__tag">
      {{ tag }}
    </div>
    <div class="price-item__inner">
      <div class="price-item__left">
        <div class="price-item__title">
          {{ item.is_default ? $t('pages.home.prices.trafficItem.noCommitments') : `${$t('pages.home.prices.trafficItem.from')} $${item.price}` }}
          <div class="price-item__sub">
            {{ item.is_default  ? '' : `/ ${$t('pages.home.prices.common.month')}` }}
          </div>
        </div>
        <div v-if="!item.is_default" class="price-item__discount">
          {{ $t('pages.home.prices.trafficItem.discount') }} {{ item.discount }}
        </div>
      </div>

      <div class="price-item__center">
        <div v-for="(type, index) in item.types" :key="index" class="price-item__type">
          <div class="price-item__text">
            {{ $t(type.name) }}
          </div>
          <div class="price-item__subtitle">
            ${{ type.price }} <span class="price-item__sub sm">/ GB</span>
          </div>
        </div>
      </div>

      <div class="price-item__right">
        <a class="price-item__btn default-tag" :href="config.public.signupUrl + queryRefParams">
          {{ $t('pages.home.prices.common.buy') }}
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.price-item {
  position: relative;
  border: var(--border-sx-main-opacity);
  background-color: var(--bg-sx-darkgray);
  border-radius: 24px;
  padding: 16px 24px;
  z-index: 9999;
  @media (max-width: 767px) {
    width: 100%;
    padding: 1rem;
  }
  &__tag {
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    background: var(--bg-sx-demiblack);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 4px 12px;
    border-radius: 8px;
    border: var(--border-sx-main-opacity);
  }
  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
  }
  &__left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    min-width: 280px;
  }
  &__center {
    display: flex;
    align-items: center;
    gap: 46px;
  }
  &__discount {
    border: var(--border-sx-secondary);
    background: #EEEEEE1A;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 4px 12px;
    border-radius: 32px;
    min-width: 116px;
  }
  &__title {
    font-weight: 700;
    font-size: 28px;
    line-height: 32px;
    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 28px;
    }
  }
  &__sub {
    font-weight: 400;
    font-size: 22px;
    line-height: 22px;
    &.sm {
      font-size: 16px;
    }
  }
  &__subtitle {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  }
  &__text {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: var(--font-sx-color-contrast);
    box-shadow: 0 1px 0 0 rgba(217, 217, 217, 0.25);
  }
  &__type {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  &__btn {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 24px;
    border-radius: 30px;
    margin-block-start: auto;
    font-size: 16px;
    line-height: 20px;
    color: #000;
    background: #fff;
    min-width: 164px;

    &:hover {
      background: #eeeeee;
    }
  }
}

@media (max-width: 1199px) {
  .price-item {
    &__inner {
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }
    &__left {
      flex-direction: column;
      gap: 16px;
      text-align: center;
    }
    &__center {
      flex-direction: column;
      gap: 16px;
      text-align: center;
    }
  }
}
</style>
